// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1AHPi","label":"LabeledBox_label__3lzL2"};